import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useLang } from '../i18n/LanguageContext';
import { loginUser } from '../services/api';

export default function LoginPage() {
  const { login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await loginUser(form);
      login(data);
      navigate('/dress-generate');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed.');
    }
    setLoading(false);
  };

  const inputClasses = "w-full px-4 py-2.5 border border-border rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-[#FA6868] focus:border-[#FA6868] transition-shadow hover:border-gray-300 shadow-sm bg-white text-gray-800";
  const labelClasses = "block text-[11px] font-semibold text-[#64748b] uppercase tracking-wide mb-2";

  return (
    <div className="min-h-screen bg-[#fafbfc] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        
        {/* Logo Header */}
        <div className="text-center mb-8">
          <span className="material-symbols-outlined text-[42px] text-[#FA6868]">checkroom</span>
          <h1 className="text-2xl font-bold text-[#FA6868] mt-2 tracking-tight">Atelier AI</h1>
          <p className="text-[#64748b] text-sm mt-2 font-medium">{t.loginSubtitle}</p>
        </div>

        {/* Card */}
        <div className="bg-white rounded-2xl shadow-soft border border-border p-8">
          <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-3">
            <span className="w-[3px] h-6 bg-[#fbbf24] rounded-full"></span>
            {t.login}
          </h2>

          {error && (
            <div className="mb-6 px-4 py-3 bg-red-50 text-[#FA6868] rounded-lg text-sm font-semibold border border-red-100 flex items-center gap-2">
              <span className="material-symbols-outlined text-[18px]">error</span>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className={labelClasses}>{t.email}</label>
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
                className={inputClasses}
                placeholder="admin@outfitapp.com"
              />
            </div>
            <div>
              <label className={labelClasses}>{t.password}</label>
              <input
                type="password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
                className={inputClasses}
                placeholder="••••••••"
              />
            </div>
            
            <button
              type="submit"
              disabled={loading}
              className={`w-full bg-[#FA6868] hover:bg-[#e65b5b] text-white font-semibold py-3 rounded-lg shadow-sm transition-all duration-200 flex justify-center items-center gap-2 text-sm mt-2 ${
                loading ? 'opacity-70 cursor-not-allowed' : 'cursor-pointer hover:shadow-md'
              }`}
            >
              {loading && <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />}
              {loading ? t.loggingIn : t.login}
            </button>
          </form>

          <p className="mt-8 text-center text-sm font-medium text-[#64748b] pt-6 border-t border-gray-100">
            {t.noAccount}{' '}
            <Link to="/register" className="text-[#FA6868] font-bold hover:underline hover:text-[#e65b5b] ml-1 transition-colors">
              {t.register}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}